<template>
    <b-navbar>
        <template slot="brand">
            <b-navbar-item tag="router-link" :to="{ path: '/' }">
                <img
                    src="../assets/images/HalfHumanLogo.png"
                    alt="Half human games"
                >
            </b-navbar-item>
        </template>
        <template slot="start">
            <!-- <b-navbar-item href="/team">
                Team
            </b-navbar-item> -->
           <b-navbar-item href="https://dwerve.com/" target="_blank">
                Dwerve
            </b-navbar-item>
            <b-navbar-item href="https://discordapp.com/invite/halfhumangames" target="_blank">
                Discord
            </b-navbar-item>
             <b-navbar-item href="https://press.halfhumangames.com/sheet.php?p=dwerve" target="_blank">
                Press
            </b-navbar-item>
             <b-navbar-item href="https://shop.halfhumangames.com/" target="_blank">
                Shop
            </b-navbar-item>
        </template>

        <template slot="end">
            <b-navbar-item tag="div">
                <div class="buttons">
                    <a class="button is-primary" v-on:click="openSendyModal();">  
                        <strong>Subscribe To Our Newsletter</strong>  
                        <b-icon
                        pack="fas"
                        icon="paper-plane"
                        size="is-small">
                        </b-icon>
                    </a>
                </div>
               
            </b-navbar-item>
        </template>
        <b-modal :active.sync="isComponentModalActive"
                 has-modal-card
                 trap-focus
                 :destroy-on-hide="false"
                 aria-role="dialog"
                 aria-modal>
            <sendy></sendy>
        </b-modal>
    </b-navbar>
</template>
<script>
import Sendy from './Sendy';
export default {
    components: {
        Sendy
    },
    data() {
        return {
            isComponentModalActive: false,
        }
     },
     methods: {
        openSendyModal() {
        document.getElementById("mySendyModal").style.display = "flex";
        },
        closeSendyodal() {
        document.getElementById("mySendyModal").style.display = "none";
        },
     }
}
</script>

<style  scoped>
nav.navbar {
    max-width: 1440px;
    border: 3px solid #FFC107;
    height: 65px;
    width: 90%;
    padding: 0px 0px;
    position: relative;
    margin: auto;
    background: linear-gradient(to bottom, #ffbf00 0%,#FFEB3B 100%);
    border-radius: 5px;
    margin-top: 59px;
    box-shadow: -10px -10px 30px 4px rgba(23, 20, 10, 0.59), 10px 10px 30px 4px rgba(24, 31, 31, 0.48);
}
.navbar-item img {
    max-height: 7.75rem;
    margin-top: -63px;
}
.navbar-item a.button.is-primary {
    background-color: #009594;
    padding: 25px 22px;
    border-radius: 39px;
    box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.23);
}
a.navbar-item {
    padding: 0 19px;
    position: relative;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.58);
    z-index: 1;
    color: #023131;
    text-transform: uppercase;
    font-weight: 400;
    font-size: 16px;
    font-family: 'Montserrat', sans-serif;
}
a.navbar-item:hover {
       background: transparent;
    color: #009594;
    text-shadow: 1px 1px 1px rgb(18, 25, 25);
}
a.navbar-item:after {
   background-image: linear-gradient(to bottom, rgba(13,104,179,0.001), #009594, rgba(13,104,179,0.001));
    bottom: 0;
    content: '';
    position: absolute;
    top: 0;
    width: 1px;
    z-index: 1;
    margin-left: -22px;
}
.navbar-brand a.navbar-item:after {
    display: none;
}
a.navbar-item:focus, a.navbar-item:focus-within{
    background-color: transparent;
    color: #fff;
}
@media only screen and (max-width: 1440px) {
  nav.navbar {
    max-width: 85% !important;
        margin-top: 45px;
    height: 50px !important;
    }   
    .navbar-item img {
        max-height: 5.75rem  !important;
        margin-top: -50px  !important;
    }
    a.button.is-primary {
  padding: 14px 15px !important;
    }
}

@media only screen and (max-width: 1023px) {
    .navbar-menu.is-active {
        background: linear-gradient(to bottom, #ffbf00 0%,#FFEB3B 100%);
        border-radius: 5px;
       margin-top: 6px;
        box-shadow: -10px -10px 30px 4px rgba(23, 20, 10, 0.59), 10px 10px 30px 4px rgba(24, 31, 31, 0.48);
    }
    a.navbar-item::after{
        display: none;
    }
    a.navbar-item {
    text-align: center;
    }
   
    .buttons {
    justify-content: center;
}
    a.navbar-burger {
        height: 2.25rem;
    }
}

</style>